//Any polyfills for older browser support can be put here - this is loaded before any other .js files in site.js
if (!String.prototype.includes) {
    String.prototype.includes = function (search, start) {
        'use strict';
        if (typeof start !== 'number') {
            start = 0;
        }
        if (start + search.length > this.length) {
            return false;
        }
        else {
            return this.indexOf(search, start) !== -1;
        }
    };
}
//# sourceMappingURL=polyfill.js.map